export default __webpack_public_path__ + "static/media/backuponline-invert.388a9df5.png";